import { render, staticRenderFns } from "./HeaderUsers.vue?vue&type=template&id=6cfd1d57&scoped=true&"
import script from "./HeaderUsers.vue?vue&type=script&lang=js&"
export * from "./HeaderUsers.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUsers.vue?vue&type=style&index=0&id=6cfd1d57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd1d57",
  null
  
)

export default component.exports